import { render, staticRenderFns } from "./consumeManagement.vue?vue&type=template&id=8648c2f4&scoped=true&"
import script from "./consumeManagement.vue?vue&type=script&lang=js&"
export * from "./consumeManagement.vue?vue&type=script&lang=js&"
import style0 from "./consumeManagement.vue?vue&type=style&index=0&id=8648c2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8648c2f4",
  null
  
)

export default component.exports